import React, { Fragment, useMemo } from "react";
import { each, isBoolean, isEmpty } from "lodash";
import PropTypes from 'prop-types'

import { DetailList } from 'camino-react'

import BooleanPill from 'Components/BooleanPill'

const ticketDefaults = {
  client_name: 'Not provided',
  lifecycleStatus: 'Not provided',
  twentyHourSupport: 'Not provided',
  client_is_managed: false,
  preferredContactMethod: 'Not provided',
  contact_name: 'Not provided',
  primary_contact_email: 'Not provided',
  contact_number: 'Not provided',
  client_contact_authorised: false,
  secondary_contact_email: 'Not provided',
}

function CompanyContent({ calligoEmployee, clientPath, clientName, lifecycle, ticket }) {
  if (calligoEmployee) {
    return ( 
      <ul>
        <li style={{ marginBottom: '2px' }}><a href={clientPath}>{clientName}</a> - <em>{lifecycle}</em></li>
        <li>
          <span className={`pill pill--${ticket.client_is_managed ? 'green' : 'red'}`}>
            {ticket.client_is_managed ? 'Managed' : 'Not Managed'}
          </span>
          <span className={`pill pill--${ticket.twentyHourSupport ? 'green' : 'red'}`}>
            24H Support
          </span>
        </li>
      </ul>
    )
  }

  return clientName
}

function CompanyContactContent({ email, phone, preferredContactMethod, client_contact_authorised, calligoEmployee, client_contact_path, contact_name = 'Not provided' }) {
  let contactName = contact_name

  if (client_contact_path && contact_name) { 
    contactName = <a href={client_contact_path} target="_blank">{contact_name}</a>
  }

  return (
    <ul>
      <li  style={{ marginBottom: '3px' }}>{contactName}</li>
      {preferredContactMethod !== 'Not provided' && <li  style={{ marginBottom: '3px' }}>Preferred Contact: {preferredContactMethod}</li>}
      <li  style={{ marginBottom: '3px' }}><span className="lnr lnr-envelope" style={{ marginRight: "1px" }} /> {email}</li>
      <li  style={{ marginBottom: '3px' }}><span className="lnr lnr-telephone" style={{ marginRight: "1px" }} /> {phone}</li>
      {calligoEmployee && (
        <li  style={{ marginBottom: '3px' }}>
          <span className={`pill pill--${client_contact_authorised ? 'green' : 'red'}`}>
            {client_contact_authorised ? 'Authorised' : 'Not Authorised'}
          </span>
        </li>
      )}
    </ul>
  )
}

function buildDetailContentList(current_user, ticket, clientPath) {
  const detailListContent = []

  detailListContent.push({
    title: 'Company',
    content: (
      <CompanyContent 
        calligoEmployee={current_user.calligo_employee}
        clientPath={clientPath}
        clientName={ticket.client_name}
        lifecycle={ticket.lifecycleStatus}
        ticket={ticket}
      /> 
    )
  })

  detailListContent.push({ 
    title: 'Company contact', 
    content: (
      <CompanyContactContent 
        email={ticket.primary_contact_email} 
        phone={ticket.contact_number}
        contact_name={ticket.contact_name}
        client_contact_path={ticket.client_contact_path}
        preferredContactMethod={ticket.preferredContactMethod}
        client_contact_authorised={ticket.client_contact_authorised}
        calligoEmployee={current_user.calligo_employee}
      /> 
    )
  })

  !isEmpty(ticket.secondary_contact_email) && detailListContent.push({ title: 'Secondary contact email', content: ticket.secondary_contact_email })

  return detailListContent
}

function ClientDetails({ current_user, ticket, clientPath }) {
  const detailListContent = useMemo(() => {
    const ticketClientDetails = {}
    each(ticket, (v, k) => { 
      if (!isBoolean(v) && isEmpty(v)) {
        ticketClientDetails[k] = ticketDefaults[k]
      } else {
        ticketClientDetails[k] = ticket[k]
      }
    })

    return buildDetailContentList(current_user, ticketClientDetails, clientPath)
  }, [ticket])

  return <DetailList full list={detailListContent} />
}

ClientDetails.propTypes = {
  current_user: PropTypes.shape({ calligo_employee: PropTypes.bool }).isRequired,
  ticket: PropTypes.shape({
    client_name: PropTypes.string,
    clientPath: PropTypes.string,
    lifecycleStatus: PropTypes.string,
    twentyHourSupport: PropTypes.string,
    client_is_managed: PropTypes.bool,
    preferredContactMethod: PropTypes.string,
    client_contact_path: PropTypes.string,
    contact_name: PropTypes.string,
    primary_contact_email: PropTypes.string,
    contact_number: PropTypes.string,
    client_contact_authorised: PropTypes.bool,
    secondary_contact_email: PropTypes.string,
  }).isRequired,
}

ClientDetails.defaultProps = {
  ticket: PropTypes.shape(ticketDefaults).isRequired,
}

export default ClientDetails
